import { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { TextFieldCustom, SelectField, DateField } from "./CustomInputs";

const DailyConsumptionForm = ({ initialValues, handleFormSubmit, buttonLabel }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [employees, setEmployees] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [employeesRes, inventoryRes] = await Promise.all([
          axios.get(`${apiUrl}/employees/role/employee`),
          axios.get(`${apiUrl}/inventory`),
        ]);
        setEmployees(employeesRes.data);
        setInventoryItems(inventoryRes.data);
      } catch (error) {
        console.error(t("data_fetch_error"), error);
      }
    };
    fetchData();
  }, [t]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={dailyConsumptionSchema(t)}
      onSubmit={handleFormSubmit}
      enableReinitialize
    >
      {(formik) => {
        console.log("✅ قيم Formik:", formik.values);
        return (
          <form onSubmit={formik.handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                direction: isRTL ? "rtl" : "ltr",
              }}
            >
              <SelectField
                name="item"
                label={t("item")}
                formik={formik}
                options={[
                  { value: "", labelKey: "select_item" },
                  ...inventoryItems.map((item) => ({
                    value: item._id,
                    label: item.itemName, // استخدام label بدلاً من labelKey
                  })),
                ]}
                grid={2}
              />
              <SelectField
                name="recordedBy"
                label={t("recorded_by")}
                formik={formik}
                options={[
                  { value: "", labelKey: "select_employee" },
                  ...employees.map((emp) => ({
                    value: emp._id,
                    label: emp.name, // استخدام label بدلاً من labelKey
                  })),
                ]}
                grid={2}
              />
              <TextFieldCustom
                name="consumedAmount"
                label={t("consumed_amount")}
                formik={formik}
                type="number"
                grid={2}
                inputProps={{ dir: "ltr" }}
              />
              <DateField
                name="consumptionDate"
                label={t("consumption_date")}
                formik={formik}
                grid={2}
              />
              <TextFieldCustom
                name="notes"
                label={t("notes")}
                formik={formik}
                grid={4}
                multiline
                rows={3}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{
                  fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif",
                  minWidth: "120px",
                }}
              >
                {buttonLabel}
              </Button>
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

const dailyConsumptionSchema = (t) =>
  yup.object().shape({
    item: yup.string().required(t("required_item")),
    recordedBy: yup.string().required(t("required_recorder")),
    consumedAmount: yup
      .number()
      .positive(t("positive_number"))
      .required(t("required_amount")),
    consumptionDate: yup.string().required(t("required_date")),
    notes: yup.string(),
  });

export default DailyConsumptionForm;